var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-layer"},[_c('div',{staticClass:"loading-flag"},[_c('div',{staticClass:"loading-layer-mian"},[_c('span',{style:({ marginLeft: _vm.left, marginTop: _vm.top }),attrs:{"id":"MessageBox"}},[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }